/**
 * @desc 设置cookie
 * */
export function setCookie(key, val, seconds, domain, path, secure) {
  let date = new Date()
  date.setTime(date.getTime() + seconds * 1000)
  let cookieString =
    key + '=' + encodeURIComponent(val) + ';expires=' + date.toGMTString()
  if (domain) {
    cookieString += ';domain=' + domain
  }
  if (path) {
    cookieString += ';path=' + path
  }
  if (secure) {
    cookieString += ';secure'
  }
  document.cookie = cookieString
}

/**
 * @desc 获取cookie
 * */
export function getCookie(key) {
  let getCookie = document.cookie
  let arrCookie = getCookie.split('; ')
  let tips
  for (let i = 0; i < arrCookie.length; i++) {
    let arr = arrCookie[i].split('=')
    if (key === arr[0]) {
      tips = arr[1]
      break
    }
  }
  if (tips) {
    return decodeURIComponent(tips)
  } else {
    return null
  }
}

/**
 * 移除cookie
 * */
export function removeCookie(name) {
  setCookie(name, '', -1)
}

// 解析url参数
export function QueryToJSON(locationSearch) {
  const url = locationSearch || location.search
  if (url.indexOf('?') >= 0) {
    let searchStr = url.substring(url.lastIndexOf('?') + 1)
    if (searchStr) {
      let param = {}
      let plist = searchStr.split('&')
      plist.forEach(function(item) {
        let paArr = item.split('=')
        let key = paArr[0]
        if (key) {
          param[key] = paArr[1] || ''
        }
      })
      return param
    } else {
      return {}
    }
  } else {
    return {}
  }
}

/**
 * @return {string}
 */
export function JsonToParams(obj) {
  let arr = []
  for (let k in obj) {
    arr.push(k + '=' + obj[k])
  }
  return arr.join('&')
}

// 防抖
// 用户动作停止后延迟x ms再执行回调
export function debounce(fn, delay) {
  delay = delay || 200
  let timer
  return function() {
    let th = this
    let args = arguments
    if (timer) {
      clearTimeout(timer)
    }
    timer = setTimeout(function() {
      timer = null
      fn.apply(th, args)
    }, delay)
  }
}

// 节流
// 用户动作时没隔一定时间（如200ms）执行一次回调
export function throttle(fn, interval) {
  let last
  let timer
  interval = interval || 200
  return function() {
    let th = this
    let args = arguments
    let now = +new Date()
    if (last && now - last < interval) {
      clearTimeout(timer)
      timer = setTimeout(function() {
        last = now
        fn.apply(th, args)
      }, interval)
    } else {
      last = now
      fn.apply(th, args)
    }
  }
}

// 对象数组按属性值排序
// @params {boolen} isAToZ 是否是从小到大排序
// export function arraySortByProperty(prop, isAToZ) {
//   return function(a, b) {
//     let returnValue = isAToZ ? 1 : -1
//     if (a[prop] < b[prop]) {
//       return -returnValue
//     }
//     if (a[prop] > b[prop]) {
//       return returnValue
//     }
//   }
// }

/**
 * @name ObjectArraySort
 * @desc 数组对象排序
 * @param {string} key
 * @param {boolean} isToNum -是否强制转数字
 * @param {string} sort - 排序方式  ASC升序 DES降序
 * */
export function ObjectArraySort(key, isToNum = false, sort = 'ASC') {
  return function(a, b) {
    if (!key) {
      return 0
    }
    const aVal = isToNum ? Number(a[key]) : a[key]
    const bVal = isToNum ? Number(b[key]) : b[key]
    if (sort.toUpperCase() === 'ASC') {
      // 升序
      return aVal > bVal ? 1 : -1
    } else if (sort.toUpperCase() === 'DES') {
      // 降序
      return aVal > bVal ? -1 : 1
    } else {
      return 0
    }
  }
}

// 解决foot fixed引起输入框问题
// solve foot position fixed problems

export function imgLoadPromise(img) {
  return new Promise(function(resolve, reject) {
    img.onload = function() {
      resolve('img loaded')
    }
    img.onerror = function() {
      let err = 'img err'
      reject(err)
    }
    if (img.complete) {
      resolve('img complete')
    }
  })
}

// let windowTop = 0
//
// export function stopBodyMove() {
//   // document.body.style.overflow = 'hidden'
//   windowTop = window.scrollY
//   document.body.style.position = 'fixed'
//   document.body.style.top = -top + 'px'
// }
//
// export function restoreBodyMove() {
//   // document.body.style.overflow = 'visible'
//   document.body.style.position = ''
//
//   document.body.style.top = ''
//   window.scrollTo(0, windowTop)
// }

export class stopRestoreBobyMove {
  constructor() {
    this._windowTop = 0
  }

  static stop() {
    this._windowTop = window.scrollY
    document.body.style.position = 'fixed'
    document.body.style.top = -this._windowTop + 'px'
  }

  static resotre() {
    document.body.style.position = ''
    document.body.style.top = ''
    window.scrollTo(0, this._windowTop)
  }
}

// 判断设备类型
export function getDeviceInfo() {
  let ua = window.navigator.userAgent
  let info = {}
  if (/iphone|ipad|ipod|ios/i.test(ua)) {
    info.device = 'ios'
  } else if (/android/i.test(ua)) {
    info.device = 'android'
  } else {
    info.device = 'android'
  }

  if (/micromessenger/i.test(ua)) {
    info.env = 'wechat'
  } else if (/weibo/i.test(ua)) {
    info.env = 'weibo'
  } else if (/mqqbrowser/i.test(ua)) {
    info.env = 'mqqbrowser'
  } else if (/qq/i.test(ua)) {
    info.env = 'qq'
  } else {
    info.env = 'other'
  }
  return info
}

// window 窗口调整时 事件 用于解决键盘弹起，底部固定部分遮挡页面元素问题
/**
 * @param {function} cb 回调函数，会把是否键盘弹起布尔值传进回调函数里执行
 * */
export function keyboardUpDown(cb) {
  let deviceInfo = getDeviceInfo()
  if (deviceInfo.device === 'ios') {
    // ios 设备
    // ios 键盘弹起
    document.body.addEventListener('focusin', () => {
      console.log('focus in')
      cb && cb(true)
    })
    // ios 键盘收回
    document.body.addEventListener('focusout', () => {
      console.log('focus out')
      cb && cb(false)
    })
  } else {
    // android 设备
    let height = window.innerHeight
    window.addEventListener('resize', function() {
      let innerheight = window.innerHeight
      cb && cb(height > innerheight)
    })
  }
}

// Fix键盘弹起收回
export function FixInputKeyBoardProblem() {
  let bodyScrollTop = 0

  function keyboardCB(bo) {
    if (bo) {
      // 键盘弹起
      bodyScrollTop = document.body.scrollTop
        ? document.body.scrollTop
        : document.documentElement.scrollTop
      console.log(bodyScrollTop)
    } else {
      if (bodyScrollTop > 0) {
        // 键盘收回
        window.scrollTo(0, bodyScrollTop)
      }
    }
  }

  keyboardUpDown(keyboardCB)
}

/**
 * @desc 数字千分
 * */
export function milliFormat(input) {
  return (
    input &&
    input.toString().replace(/(^|\s)\d+/g, function(m) {
      return m.replace(/(?=(?!\b)(\d{3})+$)/g, ',')
    })
  )
}

/**
 * @function
 * @name checkActEnd
 * @des 判断活动是否截止
 * @param {string} data
 * */
export function checkActEnd(str) {
  var nowTime = new Date().getTime()
  var endTime = new Date(...str.split(/[-\s/:]/g)).getTime()
  return nowTime > endTime
}

/**
 * @name GET_BIRTHDAY_FROM_ID
 * @desc 通过身份证号获取生日
 * @param {string} idNo
 * @return {Array} 日期数组，[year, month, day]
 * */
export function GET_BIRTHDAY_FROM_ID(idNo = '') {
  let year = idNo.substring(6, 10)
  let month = idNo.substring(10, 12)
  let day = idNo.substring(12, 14)
  return [year, month, day]
}

/**
 * @name GET_GENDER_FROM_ID
 * @desc 通过身份证号获取性别
 * @param {string} idNo
 * @return {string} - male: 男， female: 女
 * */
export function GET_GENDER_FROM_ID(idNo = '') {
  if (idNo.length === 15) {
    let genderNum = idNo.slice(-1)
    return parseInt(genderNum) % 2 === 1 ? '0' : '1'
  }
  if (idNo.length === 18) {
    let genderNum = idNo.slice(-2, -1)
    console.log('genderNum', genderNum);
    return parseInt(genderNum) % 2 === 1 ? '0' : '1'
  }
}
/**
 * @name Number_Format
 * @desc 格式化数字
 * @param  {[string | number]} number  [要格式化的数字]
 * @param  {[number]} decimals         [保留几位小数]
 * @param  {[string]} dec_point        [小数点符号]
 * @param  {[string]} thousands_sep    [千分位符号]
 * @param  {[string]} roundtag         [舍入参数，默认 "ceil" 向上取,"floor"向下取,"round" 四舍五入]
 * @return {[string]} 格式化后的结果
 */
export function Number_Format(
  number,
  decimals,
  dec_point,
  thousands_sep,
  roundtag
) {
  number = (number + '').replace(/[^0-9+-Ee.]/g, '')
  roundtag = roundtag || 'ceil' //"ceil","floor","round"
  var n = !isFinite(+number) ? 0 : +number,
    prec = !isFinite(+decimals) ? 0 : Math.abs(decimals),
    sep = typeof thousands_sep === 'undefined' ? ',' : thousands_sep,
    dec = typeof dec_point === 'undefined' ? '.' : dec_point,
    s = '',
    toFixedFix = function(n, prec) {
      var k = Math.pow(10, prec)
      console.log()

      return (
        '' +
        parseFloat(
          Math[roundtag](parseFloat((n * k).toFixed(prec * 2))).toFixed(
            prec * 2
          )
        ) /
          k
      )
    }
  s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.')
  var re = /(-?\d+)(\d{3})/
  while (re.test(s[0])) {
    s[0] = s[0].replace(re, '$1' + sep + '$2')
  }

  if ((s[1] || '').length < prec) {
    s[1] = s[1] || ''
    s[1] += new Array(prec - s[1].length + 1).join('0')
  }
  return s.join(dec)
}

/**
 * @name IsEmptyObject
 * 判断是否空对象
 * @return {boolean}
 * */
export function IsEmptyObject(obj) {
  return JSON.stringify(obj) === '{}'
}

/**
 * 赠险、付费险相同有效期
 * '2020/08/02 00:00:00'
 * '2020/09/30 23:59:59'
 */

const StartTime = '2021/03/10 00:00:00'
const EndTime = '2022/05/30 00:00:00'
export function CheckLeChengValidTime(nowDateTime) {
  console.log(nowDateTime)
  const startTime = new Date(StartTime).getTime()
  const endTime = new Date(EndTime).getTime()
  const now = new Date(nowDateTime.replace(/-/g, '/')).getTime()
  return now >= startTime && now < endTime
}

export function gethttpurl(y,x = location.href) {
  // debugger
  
  let data = {}
  let ar = x.match(/\?(.+)#|\?(.+)/)
  if(!ar){ return '' }
  ar = ar[1] ? ar[1].split('&'): ar[2].split('&')
  ar.forEach((w)=>{
    let st = w.split('=')
    data[st[0]] = st[1]
  })
  if(y){ return data[y] }
  return  data
}
//根据身份证号获取年龄
export function GetAge(identityCard) {
  let len = (identityCard + "").length;
  let strBirthday = "";
  if (len == 18) {
  //处理18位的身份证号码从号码中得到生日和性别代码
  strBirthday =
   identityCard.substr(6, 4) +
   "/" +
   identityCard.substr(10, 2) +
   "/" +
   identityCard.substr(12, 2);
  }
  if (len == 15) {
  let birthdayValue = "";
  birthdayValue = identityCard.charAt(6) + identityCard.charAt(7);
  if (parseInt(birthdayValue) < 10) {
   strBirthday =
   "20" +
   identityCard.substr(6, 2) +
   "/" +
   identityCard.substr(8, 2) +
   "/" +
   identityCard.substr(10, 2);
  } else {
   strBirthday =
   "19" +
   identityCard.substr(6, 2) +
   "/" +
   identityCard.substr(8, 2) +
   "/" +
   identityCard.substr(10, 2);
  }
  }
  //时间字符串里，必须是“/”
  let birthDate = new Date(strBirthday);
  let nowDateTime = new Date();
  let age = nowDateTime.getFullYear() - birthDate.getFullYear();
  //再考虑月、天的因素;.getMonth()获取的是从0开始的，这里进行比较，不需要加1
  if (
  nowDateTime.getMonth() < birthDate.getMonth() ||
  (nowDateTime.getMonth() == birthDate.getMonth() &&
   nowDateTime.getDate() < birthDate.getDate())
  ) {
  age--;
  }
  return age;
 }

 /**
 * @name CHECK_MOBILE_PHONE_START
 * @desc 手机号 脱敏
 * @param {string} phone 136****9325
 * @return {boolean}
 * */
  export function CHECK_MOBILE_PHONE_START(phone = '') {
    if(phone && phone.length==11 ){
        return phone.slice(0, 3) + "****" + phone.slice(phone.length - 4); 
    }
  }